import enUS from 'date-fns/locale/en-US';
import { registerLocale } from 'react-datepicker';

const customLocale = {
  ...enUS,
  localize: {
    ...enUS.localize,
    day: (n) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][n],
  },
};

registerLocale('custom', customLocale);

export default customLocale;
